var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvocado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2 7.59998C21.1735 10.3397 21.9752 13.0236 23.5 15.3C24.5502 16.9047 25.1065 18.7822 25.1 20.7C24.8578 23.0643 23.7471 25.2546 21.983 26.8472C20.2188 28.4398 17.9267 29.3215 15.55 29.3215C13.1733 29.3215 10.8812 28.4398 9.11703 26.8472C7.35291 25.2546 6.24225 23.0643 6 20.7C6.02895 18.7729 6.61976 16.8961 7.69998 15.3C9.22477 13.0236 10.0265 10.3397 10 7.59998C10 6.11476 10.59 4.6904 11.6402 3.6402C12.6904 2.58999 14.1148 2 15.6 2C17.0852 2 18.5096 2.58999 19.5598 3.6402C20.61 4.6904 21.2 6.11476 21.2 7.59998Z",
    fill: "url(#paint0_linear_20_312)",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6002 25.1C17.7541 25.1 19.5002 23.3539 19.5002 21.2C19.5002 19.0461 17.7541 17.3 15.6002 17.3C13.4463 17.3 11.7002 19.0461 11.7002 21.2C11.7002 23.3539 13.4463 25.1 15.6002 25.1Z",
    fill: "#FFFBFB",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_312",
    x1: 15.55,
    y1: 2,
    x2: 16,
    y2: 32.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.30668,
    stopColor: "#7CF997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42CE60"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvocado);
export default __webpack_public_path__ + "static/media/avocado.0a06346d2e0e5477f70e58b369f23c17.svg";
export { ForwardRef as ReactComponent };